export const BACKSPACE_KEY = 'Backspace';
export const DELETE_KEY = 'Delete';
export const ENTER_KEY = 'Enter';
export const SPACE_KEY = 'Spacebar';
export const TAB_KEY = 'Tab';
export const ARROW_KEYS = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];
